export function notEqualCheck(data, value) {
  if (data === undefined || data === null) {
    return true;
  }
  // eslint-disable-next-line eqeqeq
  if (data != value) {
    return true;
  }
  return false;
}

export const getTrimmedObjectValues = (obj) => {
  if (obj && typeof obj === 'object') {
    // eslint-disable-next-line array-callback-return
    Object.keys(obj).map((key) => {
      if (typeof obj[key] === 'object') {
        getTrimmedObjectValues(obj[key]);
      } else if (typeof obj[key] === 'string') {
        // eslint-disable-next-line no-param-reassign
        obj[key] = obj[key].trim();
      }
    });
  }
  return obj;
};
